// import React from "react";
// import RestrictedExportPage1 from "../../assets/export-updated-1.png";
// import RestrictedExportPage2 from "../../assets/export-updated-2.png";
// // import "./RestrictedExportPage.css";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Accordion,
// } from "react-bootstrap";

// const faqData = [
//   {
//     q:
//       "What are the prerequisites for applying for a Restricted Exports authorisation?",
//     a: (
//       <>
//         <p>To apply for RESTRICTED EXPORTS, following are required:</p>
//         <ul>
//           <li>Your user profile must be linked with an IEC.</li>
//           <li>
//             A valid DSC must be registered in the system. You may verify the
//             same from My Dashboard → View and Register Digital Signature Token.
//           </li>
//         </ul>
//       </>
//     ),
//   },
//   {
//     q:
//       "If my IEC is in DEL/canceled/suspended, am I eligible to apply for the authorisation?",
//     a: (
//       <>
//         <ul>
//           <li>If your IEC is in DEL, you shall be allowed to proceed with the submission of your request for issuance of the authorisation, however, your application shall only be actioned upon once your IEC is removed from DEL.</li>
//           <li>
//            If your IEC is canceled/suspended, you shall not be allowed to proceed with the submission of your request for the issuance of the authorisation.
//           </li>
//         </ul>
//       </>
//     ),
//   },
//   {
//     q:
//       "What is a file number? Where can I view my submitted applications/File number in Restricted Exports authorisation?",
//     a: (
//         <>
//             <p> When an application is submitted, a file number is generated. The application is tracked via this file number.
//                 <br />
//                 Please follow the below path to get the file number for Restricted Exports Authorisation
//             </p>
//         <ul>
//           <li>My Dashboard Submitted Applications</li>
//           <li>
//                     Enter the Type of Scheme (Select in the dropdown: Restricted Exports) and Type of Sub Scheme (Issuance of Restricted Exports Authorisation)          </li>
//                 <li> Click on Search.</li>
//                 <li>All details of submitted applications are available in the search results. These details also include their file number.</li>
//         </ul>
//       </>
//     ),
//   },
//   {
//     q:
//       "How will I get to know whether my payment is successful or failed in the system? OR Where can I check the status of my payments for an application in Restricted Exports authorisation?",
//     a: (
//         <>
//             <p> Post successful payment against your submitted application, an Acknowledgement message stating the successful submission of the application shall be shown on the screen.
//             </p>
//         <ul>
//           <li>The same can be confirmed by following the below steps:</li>
//           <li>
//                     My Dashboard  Submitted Applications </li>
//                 <li> Enter Type of Scheme (Select in dropdown: Restricted Exports) and Type of Sub Scheme</li>
//                 <li>(Issuance of Restricted Exports Authorisation)</li>
//                 <li>Click on Search</li>
//                 <li>Click on Action (Under the Results) Payment Details</li>
//         </ul>
//       </>
//     ),
//     },
//   {
//     q:
//       "What to do if my application is marked as deficient in Restricted Exports authorisation?",
//     a: (
//         <>
//             <p> If the File Status of your submitted application is marked as deficient, please follow the below steps to respond to the deficiency raised by the officer: </p>
//         <ul>
//           <li>My Dashboard  Submitted Applications</li>
//           <li> Enter the Type of Scheme (Select in the dropdown: Restricted Exports) and Type of Sub Scheme</li>
//                 <li> (Issuance of Restricted Exports Authorisation)</li>
//                 <li>Click on Search</li>
//                 <li>Click on Action (Under the Results)  Respond Deficiency</li>
//                 <li>Click on View under the Deficiency view to view the deficiency letter issued by the officer.</li>
//                 <li>To respond to deficiency, click on Respond under the Respond to Deficiency.</li>
//                 <li>A pop-up shall appear asking you Do you want to amend the application? , in case you have to add attachments only, please click on NO whereas, to make changes to your application, please click on YES.</li>
//         <li>On submission of your response, the life cycle view of the application is updated for your reference and the file is submitted to the RA officer who issued the deficiency letter.</li>
//             </ul>
//       </>
//     ),
//   },
//   {
//     q:
//       "When and how to use the feature of bulk upload for uploading of export items in Restricted Exports authorisation?",
//     a: (
//         <>
//             <p> A new feature of bulk upload has been introduced in the new system. This feature shall allow you to capture all the import and export items offline in a sample excel file, you shall only have to upload the file to update the details of import/export items.
//             </p>

//             <ul>
//                 <p>Please follow the below steps to use this feature: </p>
//           <li>In the particular section, click on the button for Download Sample Excel.</li>
//           <li>The sample excel has been downloaded to your system. Fill in the details of the items in that excel.</li>
//                 <li> Once you have added details of all the items in the excel, click on the button for Bulk upload.</li>
//                 <li>In the Upload Attachments section, click on Choose File to Upload and select the excel file that contains the details of the items.</li>
//                 <li>Now click on the button Upload to upload the file.</li>
//                 <li>The details in the file will now start to appear in the table below.</li>
//         </ul>
//       </>
//     ),
//     },
//     {
//         q: "How long is the Restricted Exports authorisation valid for? OR What is the validity of a Restricted Exports authorisation?",
//         a: (
//             <p>Restricted Exports authorisation shall be valid for imports for 24 months from the date of issuance of the authorisation.</p>
//         ),
//   },
//   {
//     q:
//       "Where can we apply for Amendment of Restricted Exports authorisation? OR Where can we get the link to apply for Amendment of Restricted Exports authorisation?",
//     a: (
//         <>
//             <p> Please follow the below path to apply for issuance of a Restricted Exports authorisation: </p>
//         <ul>
//           <li>Services  Export Management System Click on Restricted Exports</li>
//           <li>Click on Apply for Amendment of Restricted Exports authorisation</li>
//         </ul>
//       </>
//     ),
//     },
//   {
//     q:
//       "Where can we apply for the Revalidation of Restricted Exports authorisation? OR Where can we get the link to apply for the Revalidation of Restricted Exports authorisation?",
//     a: (
//         <>
//         <ul>
//           <li>Please follow the below path to apply for the issuance of a Restricted Exports authorisation: Services Export Management System Click on Restricted Exports</li>
//           <li>Click on Apply for Revalidation of Restricted Exports authorisation </li>
//          </ul>
//       </>
//     ),
//   },
//   {
//     q:
//       "How and where to enter the revalidation period and the other details necessary for applying for Revalidation?",
//     a: (
//         <>
//             <p>Please follow the given path:</p>
//         <ul>
//           <li>Open the application form, all the details will be available in view-only fields. Only the “Revalidation details” will be editable.</li>
//           <li>Enter the revalidation period and reason for revalidation</li>
//                 <li> Click on ‘Save and Next’.</li>
//                 <li>Attach the required documents</li>
//                 <li>Tick the declaration form and submit the file for processing</li>
//         </ul>
//       </>
//     ),
//   },
// ];

// export default function RestrictedExportPage() {
//   //  const [open, setOpen] = useState(0);
  

//   return (
//    <>
// <div className="bg-light py-5">

//        <section className="bg-light">
//               <Container>
//                 <Row className="g-4 align-items-start">
//                   {/* LEFT CONTENT */}
//                   <Col lg={8}>
//                     <div>

//             <h1>
// Export Authorisation for Restricted Exports (Restricted Licence)            </h1>

//             <h2>What is Restricted Export License?</h2>

//             <p>
//                       The Indian Trade Clarification (ITC) which is based on the Harmonized System of Nomenclature (HSN) of coding, classifies goods in India for the purpose of import and export. The eight-digit code used by Indian customs is also based on ITC-HS. For the export of any goods classified as 'restricted goods' in this ITC-HS list, an Restricted Export License is required.</p>
//                      <p>
//                       All items that are defined as "restricted" in the Foreign Trade Policy (FTP) / ITC (HS) Schedule 2 Export Policy 2018 may be exported subject to DGFT approval. To obtain export permits / permits, the following POE / documentation / checklist was created in consultation with the responsible ministry / raw materials department and is used by manufacturers / exporters when applying to the DGFT for an export permit for 'restricted' items:
//                   </p>
//                   </div>
//               </Col>
//                <Col lg={4}>
//                             <div className="p-4 shadow rounded right-form">
//                               <Form>
//                                 <Form.Control className="mb-3" placeholder="Name" />
//                                 <Form.Control className="mb-3" placeholder="Email" />
//                                 <Form.Control className="mb-3" placeholder="Phone" />
//                                 <Form.Control className="mb-3" placeholder="Subject" />
//                                 <Button className="w-100">Get Started</Button>
//                               </Form>
//                             </div>
//               </Col>
//               </Row>

//             <Row className="g-4 align-items-start">
//                   {/* LEFT CONTENT */}
//               <Col lg={12} xl={12}>
//                 <div className="mt-4">
                
// <img src={RestrictedExportPage1} alt="Restricted Export Page 1" className="img-fluid d-block mx-auto mb-3" />
//                   <img src={RestrictedExportPage2} alt="Restricted Export Page 2" className="img-fluid d-block mx-auto mb-3" />
//                   </div>
//                 <br/>

//                   <h2>Action on the part of DGFT (Hqrs) after receipt of application:</h2>
//                   <p>(i) After receiving the request by email in the prescribed form together with the supporting documents from the requesting company, it will be processed in the export cell.</p>
//                   <p>(ii) Based on the Standard Operating Procedure (SOP) in the DGFT, the applications are pre-selected and when the application is complete in all aspects, it will be sent to the appropriate ministry / technical department within three working days for your NOC / your Request comments / opinions.</p>
//                   <p>(iii) In case the application is deficient, the deficiency letter is sent to the applicant firm through E-mail within three working days.</p>
//                   <p>(iv) The applicant exporter is expected to respond to the query and provide requisite documents / clarification within 03 days from the receipt of DGFT email.</p>
//                   <p>(v) The request will then be emailed to the relevant ministry / technical department sent for comment / NOC;</p>
//                   <p>(vi) The Department / Technical Department is expected to provide its comments / NOC as soon as possible and no later than 30 days after receiving the request</p>
//                   <p>(vii) After receipt of the NOC's opinion, all pending applications are sent to the EXIM Facilitation Committee (EFC) in the DGFT for individual review</p>
//                   <p>(ix) The EFC usually meets once a month and mainly on the third Wednesday</p>
//                   <p>(x) Approval of the application by the EFC, Export Cell, the DGFT (HQ) creates the authorization letter and sends it with an endorsed copy to the relevant regional authority (RA) of the DGFT by e-mail and post to issue the export license;</p>
//                   <p>(xi) After approval has been granted by the DGFT (Hqrs), the company must contact the competent regional authority of the DGFT together with a copy of the letter of approval and the application submitted to the DGFT (Hqrs) with supporting documents.</p>
//                   <p>(xii) The regional authority of the DGFT must grant the applicant the export license within three working days;</p>
//                   <p>(xiii) The whole process takes 30 to 45 days.</p>
//                   <p>2. Apart from the aforementioned documents as required by DGFT, the specific documents are required from following concerned Administrative Ministries / Deptts. for grant of NOC/ recommendation and must be submitted along with the application:</p>
//                 <br/>
                  
//             <h3>Department of Fertilizers</h3>
//             <p>For NP&K fertilizers</p>

//             <h3>
//               Ministry of Environment, Forests and Climate Change (MOEF&CC)
//             </h3>
//             <p>A. For Wood and Wood Products</p>
//             <p>B. For export of Ozone Depleting Substances (ODS)</p>

//             <h3>
//               Deptt. of Agriculture Cooperation and Farmers Welfare (DOAC&FW) (Seed Division)
//             </h3>
//                   <p> Deptt. of Agriculture Cooperation and Farmers Welfare (DOAC&FW) (Seed Division)</p>
//                 <p> B. For Export of rice paddy or in Husk (non-Basmati rice) aside from seed quality</p>

//             <h3>Deptt. of Animal Husbandry, Dairying and Fisheries</h3>
//             <p>A. Live milking animal</p>
//             <p>B. Export of Live Stock (aside from milking animals)</p>

//             <h3>Ministry of Mines</h3>
//             <p>For export of sand and soil</p>

//             <h3>Deptt. of Health Research Indian Council of Medical Research</h3>
//                   <p>For export of Embryos / gametes</p>
//                   <p>1. Certificate from Indian ART Clinic</p>
//                   <p>2. Certificate from Infertile couple/subjects</p>
//                   <p>3. Certificate from foreign ART Clinic</p>
//                       <p>4. Other Documents required</p>
//                   <p>Please Note:  </p>
//                   <h2>How we Assist you?</h2>
//                   <p>Apex Services, our focus will be on your concept understanding and deliver the requirements as easy as possible in expected time. Our experienced team will help you in preparation of proper application and on words submission to DGFT. Also, we Keep a complete track on the application to arrange the required license at the earliest possible and timely replies to the queries issued by DGFT. Our team will guide you on all your post licensing requirements as well.</p>
//                       <p>Contact us +91 72077 57511
//                 </p>
                
//               </Col>
//             </Row>
//             </Container>
//         </section>


//         {/* ===== FAQ SECTION ===== */}
        
//          <section className="py-5 bg-light faq-section">
//                    <Container>
//                      <h2 className="mb-4 faq-title">
//             Frequently Asked Questions on Importer-Exporter Code (IEC)/(E-IEC)
//           </h2>
//  <Accordion defaultActiveKey="0" className="custom-faq">
//             {faqData.map((f, i) => (
//               <Accordion.Item eventKey={String(i)} key={i}>
//                 <Accordion.Header>{f.q}</Accordion.Header>
//                 <Accordion.Body>{f.a}</Accordion.Body>
//               </Accordion.Item>
//             ))}
//           </Accordion>
//         </Container>
//         </section>
//       </div>
//       </>
//  );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaIndustry,
  FaExclamationTriangle,
  FaHandsHelping
} from "react-icons/fa";
import { Accordion } from "react-bootstrap";

export default function RestrictedExport() {

  const faqData = [
    {
      q: "Who can apply?",
      a: "Any exporter holding a valid IEC can apply for restricted export authorization.",
    },
    {
      q: "Can I export without license?",
      a: "No. Restricted items require prior DGFT approval before export.",
    },
    {
      q: "How long does approval take?",
      a: "Typically 30–45 days depending on approvals and product type.",
    },
    {
      q: "What if my application is rejected?",
      a: "You can correct errors and reapply with proper documentation.",
    },
    {
      q: "Can I track my application?",
      a: "Yes, application status can be tracked through DGFT portal.",
    },
  ];

  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Export Authorization for Restricted Goods
              </h1>

              <p>
                Exporting restricted goods from India requires prior approval
                under DGFT regulations. This authorization ensures legal,
                compliant, and smooth export operations.
              </p>

              <p>
                These goods are not prohibited but require clearance from
                concerned authorities before export.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is a Restricted Export License?
          </h2>

          <p>
            A Restricted Export Authorization is a DGFT-issued license required
            for exporting goods classified as “restricted” under ITC (HS)
            Export Policy.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why Are Some Exports Restricted?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Protect natural resources</li>
            <li><FaCheckCircle /> Safeguard environment and biodiversity</li>
            <li><FaCheckCircle /> Regulate agricultural exports</li>
            <li><FaCheckCircle /> Control sensitive goods</li>
            <li><FaCheckCircle /> Ensure global compliance</li>
          </ul>

          {/* TYPES */}
          <h2 className="section-title">
            <FaList className="icon" /> Common Categories
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Agricultural products</li>
            <li><FaCheckCircle /> Natural resources</li>
            <li><FaCheckCircle /> Chemicals & hazardous goods</li>
            <li><FaCheckCircle /> Animal & biological products</li>
            <li><FaCheckCircle /> Industrial goods</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents & Approvals
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Export contract / purchase order</li>
            <li><FaCheckCircle /> DGFT application (ANF forms)</li>
            <li><FaCheckCircle /> End-use certificate</li>
            <li><FaCheckCircle /> NOC from ministries</li>
            <li><FaCheckCircle /> Environmental clearance</li>
            <li><FaCheckCircle /> IEC & business documents</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Product classification</li>
            <li><FaCheckCircle /> Documentation preparation</li>
            <li><FaCheckCircle /> DGFT online application</li>
            <li><FaCheckCircle /> Ministry review & NOC</li>
            <li><FaCheckCircle /> License issuance</li>
          </ul>

          {/* DGFT FLOW */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> DGFT Processing Flow
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Initial scrutiny by DGFT</li>
            <li><FaCheckCircle /> Sent to ministry for NOC</li>
            <li><FaCheckCircle /> Query raised if needed</li>
            <li><FaCheckCircle /> Review by committee</li>
            <li><FaCheckCircle /> Final approval</li>
          </ul>

          <p><strong>Typical Timeline:</strong> 30–45 days</p>

          {/* CHALLENGES */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Common Challenges
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Wrong classification</li>
            <li><FaCheckCircle /> Missing approvals</li>
            <li><FaCheckCircle /> DGFT delays</li>
            <li><FaCheckCircle /> Application rejection</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            We provide complete support including product classification,
            documentation, DGFT filing, and coordination with ministries to
            ensure smooth approvals and compliance.
          </p>

          {/* FAQ */}
          <h2 className="section-title mt-4">Frequently Asked Questions</h2>

          <Accordion defaultActiveKey="0" className="custom-faq">
            {faqData.map((f, i) => (
              <Accordion.Item eventKey={String(i)} key={i}>
                <Accordion.Header>{f.q}</Accordion.Header>
                <Accordion.Body>{f.a}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>

        </Container>
      </section>
    </div>
  );
}